module.exports = __webpack_public_path__ + "./fonts/DMSans-BoldItalic.267e76.woff2";